import { Container } from '@plone/components';
import PersonContact from '../../Person/PersonContact';
import ProjectContact from '../../Project/ProjectContact';

const ContactView = (props) => {
  const { content, metadata } = props;
  const contentObject = metadata || content || {};
  const hasContact = true;

  return (
    <div className="block contact ">
      {hasContact && (
        <Container className="details-container">
          {contentObject?.['@type'] === 'saw.persons.person' && (
            <PersonContact {...props} />
          )}
          {contentObject?.['@type'] === 'saw.persons.project' && (
            <ProjectContact {...props} />
          )}
        </Container>
      )}
    </div>
  );
};

export default ContactView;
